const checkReadOnlyAPI = {
  checkComponent: async (currentURL, user) => {
    let menuList = [];

    if (user && user.menu) {
      menuList = user.menu.map((menu) => {
        const newMenu = {
          key: menu.key,
          name: menu.name,
          multilevel: menu.multilevel,
          icon: menu.icon,
          readonly: menu.readonly,
          child: [],
        };

        if (menu.child) {
          newMenu.child = menu.child.map((child) => {
            const newChild = {
              key: child.key,
              name: child.name,
              multilevel: child.multilevel,
              icon: child.icon,
              readonly: child.readonly,
              link: child.link,
              child: [],
            };

            if (child.child) {
              newChild.child = child.child.map((grandchild) => ({
                key: grandchild.key,
                name: grandchild.name,
                multilevel: grandchild.multilevel,
                icon: grandchild.icon,
                readonly: grandchild.readonly,
                link: grandchild.link,
              }));
            }

            return newChild;
          });
        }

        return newMenu;
      });
    }

    let readOnly; // 기본값 설정

    if (menuList.length > 0) {
      // 중첩 함수를 생성하여 하위 메뉴들을 재귀적으로 탐색
      // eslint-disable-next-line no-inner-declarations
      function findReadOnlyStatus(menu) {
        if (menu.child && menu.child.length > 0) {
          for (const child of menu.child) {
            if (child.link === currentURL && child.readonly !== undefined) {
              readOnly = child.readonly;
              return; // 일치하는 메뉴를 찾았으므로 종료
            }

            findReadOnlyStatus(child); // 재귀적으로 하위 메뉴 탐색
          }
        }
      }

      // 모든 메뉴 아이템에 대해 검사
      for (const menu of menuList) {
        if (menu.link === currentURL && menu.readonly !== undefined) {
          readOnly = menu.readonly;
          break; // 일치하는 메뉴를 찾았으므로 종료
        }

        findReadOnlyStatus(menu); // 하위 메뉴 재귀 탐색
      }
    }

    return readOnly; // 기본값 또는 일치하는 읽기 전용 상태 반환
  },
};

export default checkReadOnlyAPI;
